"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const LoadingPlaceholder_1 = __importDefault(require("../LoadingPlaceholder"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const shared_1 = require("../../../shared");
const TextAreaRenderer = ({ control, style, }) => {
    const { Render, functions: { processor: { root: { platformOS: platform } } }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    (0, useOnLoad_1.default)(control, events);
    let Container = Render.View;
    if (events.onPress) {
        Container = Render.TouchableOpacity;
    }
    const containerStyle = (0, react_1.useMemo)(() => {
        const computedStyle = {};
        (0, shared_1.copyPropsIfDefined)(style, computedStyle, [
            'width', 'height',
            'borderStyle', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth',
            'borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius',
            'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop',
            'marginBottom', 'marginLeft', 'marginRight', 'marginTop',
            'background', 'backgroundColor', 'borderColor',
        ]);
        if (platform === 'web') {
            computedStyle.borderTopWidth = style.borderTopWidth || 0;
            computedStyle.borderRightWidth = style.borderRightWidth || 0;
            computedStyle.borderBottomWidth = style.borderBottomWidth || 0;
            computedStyle.borderLeftWidth = style.borderLeftWidth || 0;
        }
        if (style.heightAuto) {
            computedStyle.height = 'auto';
        }
        return computedStyle;
    }, [style, platform]);
    const textStyle = (0, react_1.useMemo)(() => {
        const computedStyle = {
            color: style.color,
            fontSize: style.fontSize,
        };
        computedStyle.textAlign = style.textAlign || 'left';
        computedStyle.fontWeight = style.fontWeight || 'normal';
        computedStyle.fontStyle = style.fontStyle || 'normal';
        /* This part has to be implemented on the editor on web
        if (platform === 'web') {
            computedStyle.textDecoration = style.textDecoration || 'none'
            computedStyle.wordWrap = 'break-word'
        } */
        computedStyle.textDecorationLine = style.textDecoration || 'none';
        if (platform === 'web') {
            computedStyle.whiteSpace = style.whiteSpace || 'pre-wrap';
        }
        /*
        This was to clear the text decoration to none that is the correct one
        if (computedStyle.textDecorationLine === 'unset') {
            computedStyle.textDecorationLine = 'none'
        }
        */
        return computedStyle;
    }, [style, platform]);
    const text = (0, react_1.useMemo)(() => {
        if (typeof control.text === 'object') {
            return JSON.stringify(control.text);
        }
        return control.text;
    }, [control.text]);
    return (react_1.default.createElement(LoadingPlaceholder_1.default, { control: control, style: style },
        react_1.default.createElement(Container, { style: containerStyle, onPress: events.onPress },
            react_1.default.createElement(Render.Text, { style: textStyle }, text))));
};
TextAreaRenderer.displayName = 'TextAreaRenderer';
exports.default = TextAreaRenderer;
